module.exports = __webpack_public_path__ + "img/skip-button.521ca133.png";